import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';

import { PanelBody, ToggleControl, Button } from '@wordpress/components';


import { Fragment,useState} from '@wordpress/element';

/**
 * Internal dependencies
 */

import { HorizontalLeft, HorizontalRight } from '../../../src/helpers/icon.js';

import { InserterModal as Inserter } from '../icon/components';
import { flattenIconsArray } from '../icon/utils';
import getIcons from '../icon/icons';

import { VayuBlocksAdvancePanel } from '@vayu-blocks/advance-panel';

import {
		VayuBlocksDimensions,
		VayuBlocksBorder,
		VayuBlocksColorControl,
		VayuBlocksBackground,
		VayuBlocksTypography,
		VayuBlocksAlignment,
		HeightControl,
		GroupControl,
		VayuBlocksHeaderTab,
		usePanelSettings
	} from '@vayu-blocks';

import { SlideButton } from '@vayu-blocks/global';

import ButtonEffects from '../../component/animation/button-effects';

const panelKeys = [
	'alignment-set',
	'button-effects-set',
	'button-colors-set',
	'button-border-set',
	'button-typography-set',
	'button-dimension-set'
	
];

const initialPanels = {
	setting: 'alignment-set',
	style: '',
	advanced: '',
};

const panelOptions = [
	{ label: __( 'Setting', 'vayu-blocks' ), value: 'setting', icon: 'colorwand'},
	{ label: __( 'Style', 'vayu-blocks' ), value: 'style', icon: 'diamond'},
	{ label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const InsSettings = ({props}) => {

	const {
		attributes,
		setAttributes,
		clientId
	} = props;

	const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'setting' });

	const [hover, sethover] = useState('normal');

	const handelHover = (value) => {
		sethover(value);
	}
	const isEmpty = (value) => {
		if (value == null) return true; // null or undefined
		if (typeof value === 'string' || Array.isArray(value)) return value.length === 0;
		if (typeof value === 'object') return Object.keys(value).length === 0;
		return false; // numbers, booleans, functions, etc.
	};
	
// State to control whether the Inserter component (icon inserter) is open or closed.
const [isInserterOpen, setInserterOpen] = useState(false);
const {icon,iconName} = attributes;

	    // Default to an empty string for printedIcon
const iconsAll = flattenIconsArray(getIcons());
//let printedIcon =  customIcon;
const namedIcon = iconsAll.filter((i) => i.name === iconName);
let printedIcon = !isEmpty(namedIcon) ? namedIcon[0].icon : icon;

    // Markup for the icon
	const iconMarkup = (
		<div className='box-icon' onClick={() => setInserterOpen(true)}>
			{printedIcon}
            <Button onClick={() => setInserterOpen(true)}>
                Change Icon
            </Button>
		</div>
	);

    return (<Fragment>
        <InspectorControls>
			<div className='th-block-ins th-button-panel'>
        <VayuBlocksHeaderTab 
				value={ tab }
				options={panelOptions}
				onChange={ setTab }
            />

            {'setting' === tab && (
								<Fragment>
									
								<PanelBody
									title={ __( 'General', 'vayu-blocks' ) }
									className="th-button-panel"
									opened={openPanels['alignment-set']} onToggle={() => onTogglePanel('alignment-set')}
								> 
								<VayuBlocksAlignment
                                        onChange={(key,value)=>setAttributes({[key]:value})}
                                        alignment = {{key:'alignment',value:attributes.alignment}}
										options={{justify: __('Justify', 'vayu-blocks')}}
                                />

				
							<ToggleControl
								label={ __( 'Enable Icon', 'vayu-blocks' ) }
								checked={ attributes.iconToggle }
								onChange={ iconToggle => setAttributes({ iconToggle }) }
							/>	

			{ true == attributes.iconToggle && (
				<>
					<label className='th-iconlabel'>{__( 'Icon', 'vayu-blocks' )}</label>
					<div className='vayu_blocks_icon_block_post_setting_inserter'>

					{!icon && !iconName ? (
							<div className='vayu_blocks_icon_block_post_setting'>
								Icon
							</div>
						) : (
							iconMarkup
						)}
							<Inserter
								isInserterOpen={isInserterOpen}
								setInserterOpen={setInserterOpen}
								attributes={attributes}
								setAttributes={setAttributes}
							/>
					</div>
				</>
			)}

						{ true == attributes.iconToggle && (
							<>        
                           	 <GroupControl
										label={__('Icon Position', 'vayu-blocks')}
										value={ attributes.iconPosition }
								        onChange={ iconPosition => setAttributes({ iconPosition }) }
										options={[
											{
												icon: HorizontalLeft,
												label: __( 'Before', 'vayu-blocks' ),
												value: 'before'
											},
											{
												icon: HorizontalRight,
												label: __( 'After', 'vayu-blocks' ),
												value: 'after'
											}
										]}
										
										hasIcon = {true}
									/>

		
							
							<HeightControl 
                            label={__('Icon Spacing', 'vayu-blocks')}
                            value={ attributes.iconSpacing }
                            onChange={ (value)=>setAttributes({iconSpacing:value}) }
							unitMax={{px: { max: 300, step: 1 }}} 
							customUnits={['px','%','em']}
                        />

								</>
						)}
								
								</PanelBody>

								<PanelBody title="Button Effects" initialOpen={true} 
									opened={openPanels['button-effects-set']} onToggle={() => onTogglePanel('button-effects-set')}>
									<>
									<ButtonEffects attributes={attributes} setAttributes={setAttributes} />
									</>
								</PanelBody>

								</Fragment>

		

            ) || 'advanced' === tab && (
                <Fragment>
					
				<VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId}/>
				
                </Fragment>
            ) || 'style' === tab && (
				<Fragment>

								
					 {/* Background */}
									 <PanelBody title={__('Color', 'vayu-blocks')} initialOpen={false}
									 opened={openPanels['button-colors-set']} onToggle={() => onTogglePanel('button-colors-set')}>
					 				<>
									 <VayuBlocksBackground
												onChange={(key,value)=>setAttributes({[key]:value})}
												colorPanel = {[
													{
														active: ['color'],
														label: 'Color',
														key:'color',
														value:attributes.color

													},
													{
														active: ['color'],
														label: 'Hover Color',
														key:'hoverColor',
														value:attributes.hoverColor
													}
												]}
											/>

										 <SlideButton  
											 button={{ normal: "Normal", hover: "Hover" }}
											 onChange={(value)=>handelHover(value)}
											 defaultValue={hover}
										 />  
						 
										 {hover === 'normal' && (
											 <VayuBlocksColorControl
												 onChange={(key, value) => setAttributes({ [key]: value })}
												 background={{ value: attributes.btnBackground, backgroundKey: 'btnBackground' }}
											 />
										 )}
										 {hover === 'hover' && (
											 <VayuBlocksColorControl
												 onChange={(key, value) => setAttributes({ [key]: value })}
												 background={{ value: attributes.btnBackgroundHover, backgroundKey: 'btnBackgroundHover' }}
											 />
										 )}	

									</>
											
											
									 </PanelBody>	

					{/* Border and Box Shadow */}
					<PanelBody title={__('Border & Box Shadow', 'vayu-blocks')} initialOpen={false} className="th-button-panel"
						opened={openPanels['button-border-set']} onToggle={() => onTogglePanel('button-border-set')} >
                    <SlideButton  
                        button={{ normal: "Normal", hover: "Hover" }}
                        onChange={(value)=>handelHover(value)}
                        defaultValue={hover}
                    />  
    
                    {hover === 'normal' && (
                        <VayuBlocksBorder
                            onChange={(key, value) => setAttributes({ [key]: value })}
                            border={{ key: 'btnBorder', value: attributes.btnBorder }}
                            borderRadius={{ key: 'btnBorderRadius', value: attributes.btnBorderRadius }}
                            dropShadow={{ key: 'btnDropShadow', value: attributes.btnDropShadow }}
                        />
                    )}
                    {hover === 'hover' && (
                        <VayuBlocksBorder
                            onChange={(key, value) => setAttributes({ [key]: value })}
                            border={{ key: 'btnBorderHover', value: attributes.btnBorderHover }}
                            borderRadius={{ key: 'btnBorderRadiusHover', value: attributes.btnBorderRadiusHover }}
                            dropShadow={{ key: 'btnDropShadowHover', value: attributes.btnDropShadowHover }}
                        />
                    )}
                </PanelBody>

				<PanelBody title={ __( 'Typographgy', 'vayu-blocks' ) }
							className="th-adv-h-panel" initialOpen={ false }
							opened={openPanels['button-typography-set']} onToggle={() => onTogglePanel('button-typography-set')}
						>	
					<VayuBlocksTypography
						value={attributes.typography}
						onChange={(newValues) => {setAttributes({typography:newValues})}}
					/>					   

                </PanelBody>
					
				<PanelBody title={ __( 'Dimension', 'vayu-blocks' ) }
							className="th-adv-h-panel" initialOpen={ false }
							opened={openPanels['button-dimension-set']} onToggle={() => onTogglePanel('button-dimension-set')}
						>	
					{/* Margin & Padding */}
					<VayuBlocksDimensions
										label={ __('Dimension Spacing', 'vayu-blocks') }
										onChange={(key, value) => setAttributes({ [key]: value })}
										dimensions={{
										padding: { key: 'btnPadding', value: attributes.btnPadding },
										}}
									/>
				</PanelBody>

				</Fragment>

				
			)
            
          }

		  </div>
        </InspectorControls>


      
    </Fragment>
	);
}

export default InsSettings;